import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u551131594/domains/bizzbox.social/hbuilds/source/repository/src/app/community-network/components/CommunityContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u551131594/domains/bizzbox.social/hbuilds/source/repository/src/components/AppLayout.tsx");
